<template>
  <div class="contact-page container py-5">
    <div class="card shadow-lg border-0 rounded-4 p-4 contact-card">
      <h2 class="mb-4 text-center text-white">Contact Me</h2>
      <ul class="list-group list-group-flush text-white">
        <li class="list-group-item bg-transparent border-0">
          <i class="bi bi-person-fill me-2"></i> <strong>Name:</strong> Unais VM
        </li>
        <li class="list-group-item bg-transparent border-0">
          <i class="bi bi-telephone-fill me-2"></i>
          <strong>Phone:</strong> +91 9946040267 , +971567612468
        </li>
        <li class="list-group-item bg-transparent border-0">
          <i class="bi bi-envelope-fill me-2"></i>
          <strong>Email:</strong> unaisvattamannil@gmail.com
        </li>
        <li class="list-group-item bg-transparent border-0">
          <i class="bi bi-linkedin me-2"></i>
          <strong>LinkedIn:</strong>
          <a href="https://linkedin.com/in/unaisvattamannil" target="_blank" class="text-white text-decoration-underline">
            unaisvattamannil
          </a>
        </li>
      </ul>

      <!-- Buttons -->
      <div class="text-center mt-4">
        <a href="mailto:unaisvattamannil@gmail.com" class="btn btn-light me-2">
          <i class="bi bi-envelope-fill"></i> Email Me
        </a>
       
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ContactPage"
};
</script>

<style scoped>
.contact-card {
  background: linear-gradient(135deg, #0d6efd, #6610f2); /* Blue-Purple Gradient */
  color: #fff;
  border-radius: 16px;
}

.list-group-item {
  font-size: 1.1rem;
}

.btn {
  font-weight: bold;
}

.btn:hover {
  transform: scale(1.05);
  transition: 0.3s ease;
}
</style>
